import $http from "./http";
import config from "./config";
export default {
    name: 'activity',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getActiveList(data) {
        return $http.post(this.getUrl(`/ActiveInfo/List`), data);
    },
    getActiveInfo(ActiveId) {
        return $http.get(this.getUrl(`/ActiveInfo/Details?id=${ActiveId}`));
    },
    getSaveActive(data) {
        return $http.post(this.getUrl(`/ActiveInfo/Save`), data);
    },
    getSearchAccount(data) {
        return $http.post(this.getUrl(`/activeinfo/SearchAccount`), data);
    },
    enterInto(data, options) {
        //data= {ActiveId:'',TargetCode:'',ActiveCode:'DailySignIn'}
        return $http.post(this.getUrl("/ActiveInfo/EnterInto"), data, options);
    },
    getRecordList(data) {
        //data= {ActiveId:'',TargetCode:'2019-05-31',ActiveCode:'DailySignIn'}
        return $http.post(this.getUrl(`/RecordInfo/List`), data);
    },
    getInsulation(depart, arrive) {
        return $http.get(this.getUrl(`/common/gelizhengce?depart=${(depart || "").replace("市", "")}&arrive=${(arrive || "").replace("市", "")}`),{failTips:false});
    },
    getCommonList(){
        return $http.get(this.getUrl('/common/list'));
    },
    commonupdate(data){
        return $http.post(this.getUrl('/common/update'),data);
    },
    commondelete(id){
        return $http.get(this.getUrl('/common/delete?companyid='+id))
    }
}



// WEBPACK FOOTER //
// ./src/apis/activityApis.js